import { POLICYSTREAM_FORMS } from '../constants';
import { generalApplicationAnswers } from './data';

// types and classes
import type { FormAnswers } from './types';
// policies

export const cannedAnswers: Array<FormAnswers> = [
  {
    internalName: POLICYSTREAM_FORMS.applicationForm,
    answers: generalApplicationAnswers,
  },
];
